import React, { useState } from "react";
import { TableContainer } from "./table-style";
import { TableProps } from "./table-types";

const Table = ({ headRow, bodyRows, footerRow, className }: TableProps) => {
  const [contractedList, setContractedList] = useState<string[]>([]);

  const toggleContractedItems = (contractActionList?: string[]) => {
    if (!contractActionList || !contractActionList.length) return;

    setContractedList((prevList) => {
      const newContractedList = new Set(prevList);
      contractActionList.forEach((item) => {
        if (newContractedList.has(item)) newContractedList.delete(item);
        else newContractedList.add(item);
      });
      return Array.from(newContractedList);
    });
  };

  const getContractedItem = (contractByList?: string[]) => {
    if (!contractByList || !contractByList.length) return false;
    return contractByList.some((item) => contractedList.includes(item));
  };

  return (
    <TableContainer className={className}>
      <table>
        <thead>
          <tr className={headRow.className}>
            {headRow.cells.map((cell, index) => (
              <th key={`head${index}`} className={cell.className}>
                {cell.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {bodyRows.map((row, index) => {
            const isContractedRow = getContractedItem(row.contractByList);

            return (
              <tr
                key={`row${index}`}
                className={`${row.className}  ${
                  isContractedRow ? "row-contracted" : "row-extended"
                }`}
              >
                {row.cells.map((cell, cellIndex) => {
                  const contractActionList = cell.contractActionList;
                  const hasAction = contractActionList ? true : false;
                  const isChecked =
                    contractActionList &&
                    contractActionList.some((item) => contractedList.includes(item));

                  return (
                    <td key={`cell${cellIndex}`} className={`${cell.className}`}>
                      {hasAction && (
                        <input
                          type="checkbox"
                          onClick={() => toggleContractedItems(cell.contractActionList)}
                          checked={isChecked}
                        />
                      )}
                      {cell.value}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        {footerRow && (
          <tfoot>
            <tr className={footerRow.className}>
              {footerRow.cells.map((cell, index) => (
                <td key={`foot${index}`} className={cell.className}>
                  {cell.value}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </TableContainer>
  );
};

export default Table;
